class Monitoring.Methods.AnalyticsAsyncJob extends Backbone.View

  start: (params) =>
    @job = new ResqueJob
      url: '/monitoring/publications/analytics_export',
      data: params
      success: (results) =>
        @trigger('completed', results)
      error: =>
        @trigger('failed')
    @job.start()

  stop: ->
    @job.stop()
